import { Button, Form } from "react-bootstrap";
import { ChangeEvent, useState, useEffect } from "react";
import { useAuth } from "../../../utils/auth";
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';
import { ApiErrorResponse } from "../../../types/ApiErrorResponse";

interface FormData {
	email: string;
	password: string;
}

export const LoginForm = () => {
	const supportedLanguages = ["es", "en", "ca"]; // Idiomas que tu app soporta
	const defaultLanguage = "ca"; // Idioma por defecto
	const [error, setError] = useState<string>('');
	const [language, setLanguage] = useState<string>('');
	const navigate = useNavigate();

	//Language settings
	const { t, i18n } = useTranslation(['auth']);
	useEffect(() => {
		const lang = getBrowserLanguage();
		setLanguage(lang)
		i18n.changeLanguage(lang);
		//setError(t("common:requestError.accessDenied"));
		const stored = sessionStorage.getItem("loginError");
		if (stored) {
			const error = JSON.parse(stored);

			if (error.code === "ERROR_IP_NOT_ALLOWED") {

				setError(error.message);

			}

			sessionStorage.removeItem("loginError");
		}
	}, []);

	const getBrowserLanguage = () => {
		const lang = navigator.language;
		const shortLang = lang.split("-")[0]; // "es-ES" -> "es"
		return supportedLanguages.includes(shortLang) ? shortLang : defaultLanguage;
	};

	//FormData methods
	const [formData, setFormData] = useState<FormData>({
		email: '',
		password: ''
	});

	const handleChange = (e: ChangeEvent<HTMLInputElement>): void => {
		const { name, value } = e.target;
		setFormData({
		...formData,
		[name]: value
		});
	};

	//Restore pwd
	const handleClick = (e: React.FormEvent) => {
		e.preventDefault();
		navigate(`/restoreEmail/${language}`);
	};

	//Authenticate
	// const { setUserInfo } = useUser();
	const { authenticate } = useAuth({
		config: {
			onError: (error) => {
				const fetchError = error as ApiErrorResponse;
				const errorData = fetchError?.message;
				if (fetchError?.code?.includes("ERROR_IP_NOT_ALLOWED")) {
					setError(fetchError?.message);
					return;
				}
				if (errorData?.includes("UNAUTHORIZED_ROLEPERMISION_ACCESS")) {
					setError(t("auth:unauthorizedRolePermissionError"));
				} else {
					setError(t("auth:authUserErrorMessage"));
				}
			},
		},
	});

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		if (!formData.email || !formData.password) {
			setError(t("auth:authUserErrorMessage2"));
			return;
		}
		setError("");
		await authenticate(formData);

		// setUserInfo(responseData.user);
	};

	return (
		<Form onSubmit={handleSubmit}>
			<Form.Group className="mb-3">
				<Form.Label>{t("auth:textLoginUser")}</Form.Label>
				<Form.Control
					type="text"
					name="email"
					value={formData.email}
					onChange={handleChange}
				/>
			</Form.Group>

			<Form.Group className="mb-4">
				<Form.Label>{t("auth:textLoginPassword")} </Form.Label>
				<Form.Control
					type="password"
					name="password"
					autoComplete="current-password"
					value={formData.password}
					onChange={handleChange}
				/>
			</Form.Group>

			{error && <div className="alert alert-danger mb-3">{error}</div>}
			<div className="d-flex justify-content-end">
				<p onClick={handleClick} style={{ cursor: "pointer", marginRight: "70px", color: "grey" }}>
					{t("auth:textForgotPassword")}
				</p>

				<Button variant="success" type="submit">
					{t("auth:textButtonLogin")}
				</Button>
			</div>
		</Form>
	);
}

